import script from "./EventsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EventsTable.vue?vue&type=script&setup=true&lang=js"

import "./EventsTable.vue?vue&type=style&index=0&id=616591bc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-616591bc"]])

export default __exports__